export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Project Apollo Runs',
      url: '/vdpRuns',
      icon: 'icon-control-play'
    },
    {
      name: 'XML Counts Report',
      url: '/projectApollo/xmlCntRpt',
      icon: 'icon-note'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js